import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const privacyContent = {
  title: 'Política de Privacidad',
  body: `Última actualización: Abril 2026

Tu privacidad es importante para nosotros. Esta política describe cómo recopilamos, usamos y protegemos tu información personal.

Información que recopilamos
Cuando realizás una compra, recopilamos tu nombre, dirección de correo electrónico y datos de pago necesarios para procesar tu pedido. No almacenamos datos de tarjetas de crédito en nuestros servidores.

Uso de la información
Utilizamos tu información exclusivamente para:
• Procesar y entregar tu compra digital.
• Enviarte el producto adquirido por correo electrónico.
• Comunicarte actualizaciones importantes sobre tu compra.

No vendemos, alquilamos ni compartimos tu información personal con terceros con fines comerciales.

Cookies
Nuestro sitio puede utilizar cookies para mejorar tu experiencia de navegación y analizar el tráfico del sitio. Podés configurar tu navegador para rechazar cookies.

Seguridad
Implementamos medidas de seguridad estándar de la industria para proteger tu información personal contra acceso no autorizado.

Tus derechos
Tenés derecho a acceder, corregir o eliminar tu información personal en cualquier momento. Para ejercer estos derechos, podés contactarnos por correo electrónico.

Cambios en esta política
Nos reservamos el derecho de actualizar esta política en cualquier momento. Los cambios serán publicados en esta página.`
};
const termsContent = {
  title: 'Términos y Condiciones',
  body: `Última actualización: Abril 2026

Al acceder y utilizar este sitio web y adquirir nuestros productos digitales, aceptás los siguientes términos y condiciones.

Producto digital
"AirFryer Criolla Express" es un producto digital en formato PDF. Una vez realizada la compra, recibirás acceso inmediato al material.

Uso personal
El contenido adquirido es para uso personal y no comercial. Queda prohibida la reproducción, distribución o reventa del material sin autorización expresa.

Propiedad intelectual
Todo el contenido, incluyendo textos, imágenes, técnicas y métodos descritos, está protegido por derechos de autor. La compra del producto no transfiere derechos de propiedad intelectual.

Política de reembolso
Debido a la naturaleza digital del producto y su entrega inmediata, no se ofrecen reembolsos una vez completada la descarga. Si tenés problemas técnicos para acceder al producto, contactanos y te ayudaremos a resolverlo.

Limitación de responsabilidad
Los resultados pueden variar según el modelo de AirFryer, los ingredientes utilizados y la técnica aplicada. No garantizamos resultados específicos.

Modificaciones
Nos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuado del sitio después de los cambios constituye la aceptación de los nuevos términos.

Ley aplicable
Estos términos se rigen por las leyes de la República Argentina.`
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const content = activeModal === 'privacy' ? privacyContent : activeModal === 'terms' ? termsContent : null;
  return <>
      <footer className="bg-charcoal-light border-t border-white/5 py-8 px-6" data-id="element-50">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-51">
          <p className="font-sans text-sm text-cream/30" data-id="element-52">
            © 2026 AirFryer Criolla Express. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-53">
            <button onClick={() => setActiveModal('privacy')} className="font-sans text-sm text-cream/50 hover:text-amber transition-colors" data-id="element-54">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="font-sans text-sm text-cream/50 hover:text-amber transition-colors" data-id="element-55">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-56">
        {activeModal && content && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-57">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-charcoal-light border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-58">
              <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-59">
                <h3 className="font-serif text-xl md:text-2xl font-bold text-cream" data-id="element-60">
                  {content.title}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-cream/50 hover:text-cream transition-colors p-1" data-id="element-61">
                  <X size={24} data-id="element-62" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-63">
                <div className="font-sans text-sm text-cream/70 leading-relaxed whitespace-pre-line" data-id="element-64">
                  {content.body}
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}